import { Button, Stack } from "@mui/material";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as z from "zod";

import { useCreateNotificationHandlerNotificationHandlersPostMutation } from "api";
import { TextInput } from "components/forms";
import { INotificationHandlerEmail } from "interfaces/notification.interface";

const emailHandlerSchema = z.object({
  description: z.string(),
  configuration: z.object({
    recipients: z.array(z.email()),
  }),
});

type EmailHandlerSchema = z.infer<typeof emailHandlerSchema>;

type TempEmailProps = {
  disabled: boolean;
  zoneId: string;
  onClose: () => void;
  defaultValues: INotificationHandlerEmail | null;
};

export function TempEmail({
  disabled,
  zoneId,
  onClose,
  defaultValues,
}: TempEmailProps) {
  const { t } = useTranslation();

  const [createHandler] =
    useCreateNotificationHandlerNotificationHandlersPostMutation();

  const { control, handleSubmit } = useForm<EmailHandlerSchema>({
    resolver: zodResolver(emailHandlerSchema),
    defaultValues: defaultValues ?? {},
  });

  const onCreate = async (data: EmailHandlerSchema) => {
    await createHandler({
      notificationHandlerCreate: {
        type: "email",
        zone_id: zoneId,
        enabled: true,
        ...data,
      },
    });

    onClose();
  };

  return (
    <Stack component={"form"} onSubmit={handleSubmit(onCreate)} gap={1}>
      <TextInput
        fieldName={"description"}
        control={control}
        label={t("Description")}
        placeholder={t("notification_email_handler_description_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.recipients.0"}
        control={control}
        label={t("Email")}
        placeholder={t("notification_email_handler_recipients_placeholder")}
        disabled={disabled}
        required
      />
      <Stack gap={2} direction={"row"}>
        {!defaultValues && <Button type={"submit"}>{t("Create")}</Button>}
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
      </Stack>
    </Stack>
  );
}
